import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

/**
 * Ação de kebab BLOQUEADA — cadeado + motivo, o idioma da casa pra "por que
 * este comando não funciona aqui".
 *
 * ⚠️ Extraído do `PlanAllWeeksView` no 2º caller (2026-08-25). O plano COMPLETO
 * já desabilitava a ação com cadeado e tooltip; o plano da SEMANA deixava o
 * professor clicar em "Remover item" e só explicava no dialog. Mesma pergunta,
 * duas respostas — e copiar o desenho pro segundo lugar era o jeito garantido de
 * eles divergirem no primeiro ajuste.
 *
 * 🔴 O dialog NÃO sai de cena: ele continua cobrindo a CORRIDA — entre carregar
 * a tela e clicar, um aluno pode começar. Desabilitar com base em
 * `hasStudentWork=true` é seguro (esse fato só fica mais verdadeiro); quem
 * recusa o caso desconhecido continua sendo o servidor.
 */
/**
 * Envolve a ação bloqueada com o motivo — mesmo idioma do kebab do
 * `DataTable` (Console › Usuários, "Você não pode bloquear sua própria
 * conta").
 *
 * <p>⚠️ O `<span>` no meio não é enfeite: item desabilitado <b>não dispara
 * evento de mouse</b>, então o gatilho do tooltip precisa de um elemento vivo
 * por fora.
 *
 * <p>🔴 Por que aqui e não uma frase no topo do menu: as duas ações travam por
 * motivos DIFERENTES — uma pela própria semana, outra por uma seguinte. Aviso
 * único no topo não consegue dizer os dois, e obrigaria o professor a adivinhar
 * qual cadeado corresponde a qual frase.
 */
export const MaybeLocked = ({ locked, reason, wrapClass, children }) =>
	locked ? <LockedAction reason={reason} wrapClass={wrapClass}>{children}</LockedAction> : children;

export const LockedAction = ({ reason, placement = 'left', wrapClass = 'd-inline-block', children }) => (
	<OverlayTrigger placement={placement} overlay={<Tooltip>{reason}</Tooltip>}>
		<span className={wrapClass}>{children}</span>
	</OverlayTrigger>
);

/**
 * O cadeado ao lado da AÇÃO — não da linha. Ele responde "por que este comando
 * não funciona aqui", e essa pergunta só existe no menu: na linha, o mesmo
 * ícone dizia que a semana inteira estava trancada, o que é falso (exportar
 * segue valendo).
 */
export const LockMark = () => (
	<svg className="kb-item-lock" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="4" y="11" width="16" height="10" rx="2" />
		<path d="M8 11V7a4 4 0 0 1 8 0v4" />
	</svg>
);

